module.exports = __webpack_public_path__ + "img/2-10.3da2af51.svg";